import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import RichTable from '../components/richTable/RichTable.jsx'
import TableHelpers from '../helpers/TableHelpers.js';
import { CircularProgress } from '@mui/material';
import AutomateTrade from './AutomateTrade.js'
import OptionSelector from './OptionSelector.js'
import Tooltip from '../components/Tooltip.js'
import Dropdown from 'react-bootstrap/Dropdown';

function Scalper(props) {

    const [isLoading, setIsLoading] = useState(false);
    const [isPlacingOrder, setIsPlacingOrder] = useState(false);
    const [trade, setTrade] = useState(null);
    const [brokerageAccount, setBrokerageAccount] = useState(null);
    const [updates, setUpdates] = useState(0);
    const [quotes, setQuotes] = useState([]);
    const [symbols, setSymbols] = useState([]);
    const [symbol, setSymbol] = useState("SPY");
    const [dailyPnl, setDailyPnl] = useState([]);

    useEffect(() => {
        (async function () {

            setIsLoading(true);

            const syms = await (await fetch(`/api/strategySymbols`)).json();
            setSymbols(syms);

            const quotesUrl = "/api/quote?symbols=" + syms.join(",");
            const q = await (await fetch(quotesUrl)).json();
            console.log("Quotes fetched", q);
            if (q) {
                setQuotes(q);
            }

            const pnlUrl = "/api/dailyOptionsPnl?userId=" + props.userId + "&accountId=" + props.accountId;
            const data = await (await fetch(pnlUrl)).json();
            console.log("PNL", data);
            if (data && data.success) {
                setDailyPnl(data.data);
            }

            const url = "/api/brokerageAccounts?userId=" + props.userId + "&brokerage=schwab"
            const brokerageAccounts = await (await fetch(url)).json();
            console.log("brokerageAccounts", brokerageAccounts);
            if (brokerageAccounts.success && brokerageAccounts.accounts) {
                let brokerageAccount = brokerageAccounts.accounts.find(act => act.accountId === Number(props.accountId));
                if (brokerageAccount) {
                    setBrokerageAccount(brokerageAccount);
                } else {
                    console.log("Could not find brokerage account for " + props.accountId)
                    setBrokerageAccount(null);
                }
            }

            setIsLoading(false);
        })();
    }, [updates, props.accountId, props.userId]);

    function openPlaceTradeModal(symbol, quantity) {
        console.log("Opening trade modal", symbol, quantity);
        setTrade({
            symbol: symbol,
            shares: Number(quantity),
            marketOrder: Number(quantity) > 0
        })
        setIsPlacingOrder(true);
    }

    async function onCancelOrder(orderId) {

        const url = "/api/brokerageOrderCancel?brokerage=schwab&userId=" + props.userId + "&accountId=" + props.accountId + "&orderId=" + orderId
        let result = await (await fetch(url, { method: 'post' })).json();
        console.log("order cancel response", result);

        setUpdates(updates + 1);
        console.log(result);
    }

    function symbolFormatter(cell, row) {
        if (!row.openAmount) {
            return <>{cell} <Link onClick={() => openPlaceTradeModal(cell, row.shares * -1)}> ⤵️</Link></>
        } else {
            return (
                <>
                    {cell}<Tooltip text={" ✳️"}>
                        OrderId: {row.openOrderId}
                        <br></br>
                        Open Shares: {row.openAmount}
                        <br></br>
                        Limit Price: {row.openPrice}
                        <br></br>
                        Stop Price: {row.openStopPrice}
                        <br></br>
                        <br></br>
                        <button class="btn btn-danger" onClick={() => onCancelOrder(row.openOrderId)} type="button">Cancel Order</button>
                    </Tooltip>
                </>
            );
        }
    }

    function onTradeClosed() {
        setIsPlacingOrder(false);
        setTrade(null);
        setUpdates(updates + 1);
    }

    function getQuote(symbol) {
        if (quotes) {
            let q = quotes.find(q => q.symbol === symbol);
            if (q) {
                return q.last;
            }
        }
        return 0;
    }

    function getOptionPositions() {
        let ret = [];
        if (brokerageAccount && brokerageAccount.positions) {
            return brokerageAccount.positions.filter(p => p.securityType === "OPTION").map(position => {
                let openOrder = brokerageAccount.openOrders ? brokerageAccount.openOrders.find(order => order.symbol === position.netSymbol) : null;
                return {
                    netSymbol: position.symbol,
                    shares: position.shares,
                    marketValue: position.marketValue,
                    currentProfitLoss: position.currentProfitLoss,
                    openAmount: openOrder ? openOrder.shares : 0,
                    openPrice: openOrder ? openOrder.price : 0,
                    openStopPrice: openOrder ? openOrder.stopPrice : 0,
                    openOrderId: openOrder ? openOrder.orderId : undefined
                };
            })
        }
        return ret;
    }

    function getTradeStats() {
        let ret = [];
        let stats = {}
        if (brokerageAccount && brokerageAccount.trades) {
            stats.count = brokerageAccount.trades.length;
            let buys = 0;
            let sells = 0;
            for (let i = 0; i < brokerageAccount.trades.length; i++) {
                let trade = brokerageAccount.trades[i];
                if (trade.securityType === "OPTION") {
                    if (trade.instruction === "BUY_TO_OPEN") {
                        buys += trade.price * trade.shares;
                    } else if (trade.instruction === "SELL_TO_CLOSE") {
                        sells += trade.price * trade.shares;
                    }
                };
            }
            stats.dollarProfit = (sells - buys) * 100;
            ret.push(stats);
            return ret;
        }
    }
    function getOptionTrades() {
        let ret = [];
        if (brokerageAccount && brokerageAccount.trades) {
            return brokerageAccount.trades.filter(p => p.securityType === "OPTION").map(trade => {
                return {
                    netSymbol: trade.symbol,
                    price: trade.price,
                    shares: trade.shares,
                    instruction: trade.instruction,
                };
            })
        }
        return ret;
    }

    function onSymbolChanged(e) {
        setSymbol(e);
        setUpdates(updates + 1);
    }

    return (
        <>
            <h4>Current Positions</h4>
            {isLoading ?
                <CircularProgress />
                :
                <>
                    {brokerageAccount ?
                        <RichTable pageSize={10} headless={false} data={getOptionPositions()} className="table-condensed" mappers={[
                            { title: 'Symbol', field: 'netSymbol', formatter: symbolFormatter },
                            { title: 'Contracts', field: 'shares', formatter: TableHelpers.intFormatter },
                            { title: 'Market Value', field: 'marketValue', formatter: TableHelpers.moneyFormatter },
                            { title: 'P/L', field: 'currentProfitLoss', formatter: TableHelpers.percentChangeFormatter }
                        ]} />
                        :
                        "No brokerage account"
                    }
                    <br></br>
                    <Link onClick={() => setUpdates(updates + 1)}>Reload</Link>
                </>
            }

            <br></br>
            <br></br>
            <div className='sameline'>
                Symbol&nbsp;<Dropdown width="150" onSelect={(e) => onSymbolChanged(e)}>
                    <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                        {symbol ? symbol : "Select symbol"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu  >
                        {symbols.sort().map(sym => {
                            return (<Dropdown.Item as='symbol' eventKey={sym} value={sym}>{sym}</Dropdown.Item>)
                        })}
                    </Dropdown.Menu>
                </Dropdown>
                <h4>{getQuote(symbol).toFixed(2)}</h4>
            </div>
            <hr></hr>

            <table width="100%">
                <tr style={{ backgroundColor: 'transparent' }}>
                    <td><h5>Calls</h5></td>
                    <td><h5>Puts</h5></td>
                </tr>
                <tr style={{ backgroundColor: 'transparent', verticalAlign: 'top' }}>
                    <td width={"50%"}>
                        <OptionSelector mobileView={props.mobileView} symbol={symbol} callPut={"call"} planId={props.planId} userId={props.userId} brokerage="schwab" accountId={props.accountId} />
                    </td>
                    <td>
                        <OptionSelector mobileView={props.mobileView} symbol={symbol} callPut={"put"} planId={props.planId} userId={props.userId} brokerage="schwab" accountId={props.accountId} />
                    </td>
                </tr>
            </table>
            <hr></hr>
            <br></br>
            <h4>Todays Trades</h4>
            {isLoading ?
                <CircularProgress />
                :
                <>
                    {brokerageAccount ?
                        <>
                            <RichTable headless={false} data={getTradeStats()} className="table-condensed" mappers={[
                                { title: 'Trades', field: 'count', formatter: TableHelpers.intFormatter },
                                { title: 'Profit', field: 'dollarProfit', formatter: TableHelpers.moneyFormatter },
                            ]} />

                            <RichTable pageSize={20} headless={false} data={getOptionTrades()} className="table-striped table-hover table-condensed" mappers={[
                                { title: 'Symbol', field: 'netSymbol', formatter: symbolFormatter },
                                { title: 'Action', field: 'instruction' },
                                { title: 'Contracts', field: 'shares', formatter: TableHelpers.intFormatter },
                                { title: 'Price', field: 'price', formatter: TableHelpers.moneyFormatter },
                            ]} />
                        </>
                        :
                        "No brokerage account"
                    }

                    <br></br>
                    <br></br>
                    <h4>Daily P&L</h4>
                    <RichTable pageSize={20} headless={false} data={dailyPnl} className="table-striped table-hover table-condensed" mappers={[
                        { title: 'Date', field: 'date', formatter: TableHelpers.dateFormmatter },
                        { title: 'Trades', field: 'trades', formatter: TableHelpers.intFormatter },
                        { title: 'Profit', field: 'dollar_profit', formatter: TableHelpers.moneyFormatterNoCents },
                        { title: 'Cumulative', field: 'net', formatter: TableHelpers.moneyFormatterNoCents },
                    ]} />
                </>
            }

            <AutomateTrade brokerage={props.brokerage} trade={trade} userId={props.userId} accountId={props.accountId} isOpen={isPlacingOrder} onClose={() => onTradeClosed(false)} mobileView={props.mobileView} />
        </>
    );
}

export default Scalper;